@file:OptIn(org.jetbrains.compose.resources.ExperimentalResourceApi::class)

package com.essntl.features.service.ui.components.richtext

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.resources.LocalRes
import com.essntl.uikit.theme.esColorScheme
import com.mohamedrejeb.richeditor.model.RichTextState
import org.jetbrains.compose.resources.painterResource

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun RichEditorPanel(
    richTextState: RichTextState,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    aiEnabled: Boolean = false,
    onRewriteWithAI: () -> Unit,
) {
    val res = LocalRes.current

    var isLinkDialogOpen by remember { mutableStateOf(false) }

    FlowRow(
        verticalArrangement = Arrangement.spacedBy(8.dp),
        horizontalArrangement = Arrangement.spacedBy(12.dp),
        modifier = modifier,
    ) {
        if (aiEnabled) {
            Image(
                painter = painterResource(res.aiEssntl),
                contentDescription = "Odia AI",
                modifier =
                    Modifier
                        .height(26.dp)
                        .width(52.dp)
                        .clip(RoundedCornerShape(8.dp))
                        .background(MaterialTheme.esColorScheme.bgSecondary)
                        .pointerHoverIcon(PointerIcon.Hand)
                        .clickable(
                            onClick = onRewriteWithAI,
                        ),
            )
        }

        RichEditorPanelAlignItem(
            richTextState = richTextState,
            enabled = enabled,
        )

        RichEditorPanelIconItem(
            res = EsIcons.TextBold,
            selected = richTextState.currentSpanStyle.fontWeight == FontWeight.Bold,
            enabled = enabled,
            onClick = {
                richTextState.toggleSpanStyle(SpanStyle(fontWeight = FontWeight.Bold))
            },
        )

        RichEditorPanelIconItem(
            res = EsIcons.TextItalic,
            selected = richTextState.currentSpanStyle.fontStyle == FontStyle.Italic,
            enabled = enabled,
            onClick = {
                richTextState.toggleSpanStyle(SpanStyle(fontStyle = FontStyle.Italic))
            },
        )

        RichEditorPanelIconItem(
            res = EsIcons.TextUnderline,
            selected = richTextState.currentSpanStyle.textDecoration == TextDecoration.Underline,
            enabled = enabled,
            onClick = {
                richTextState.toggleSpanStyle(SpanStyle(textDecoration = TextDecoration.Underline))
            },
        )

        RichEditorPanelIconItem(
            res = EsIcons.TextStrikethrough,
            selected = richTextState.currentSpanStyle.textDecoration == TextDecoration.LineThrough,
            enabled = enabled,
            onClick = {
                richTextState.toggleSpanStyle(SpanStyle(textDecoration = TextDecoration.LineThrough))
            },
        )

        RichEditorPanelIconItem(
            res = EsIcons.ListBulleted,
            selected = richTextState.isUnorderedList,
            enabled = enabled,
            onClick = {
                richTextState.toggleUnorderedList()
            },
        )

        RichEditorPanelIconItem(
            res = EsIcons.ListNumbered,
            selected = richTextState.isOrderedList,
            enabled = enabled,
            onClick = {
                richTextState.toggleOrderedList()
            },
        )

        RichEditorPanelIconItem(
            res = EsIcons.Link,
            selected = richTextState.isLink,
            enabled = enabled,
            onClick = {
                isLinkDialogOpen = true
            },
        )

        RichEditorPanelTypeItem(
            richTextState = richTextState,
            enabled = enabled,
        )
    }

    if (isLinkDialogOpen) {
        RichEditorLinkDialog(
            state = richTextState,
            onDismissRequest = {
                isLinkDialogOpen = false
            },
        )
    }
}
